import { defineQuery, useQuery } from '@pinia/colada';
import { computed } from 'vue';

import { getStarImprovement } from '@/apis/library-intelligence';
import { QueryKeys } from '@/shared/queries/keys';
import { CACHE_TIMES } from '@/shared/queries/options';
import { useIdentityStore } from '@/stores/identity';

/** Backend computes the value async — poll until `ready`. */
const NOT_READY_POLL_MS = 5 * 60 * 1000;

export const useStarImprovementQuery = defineQuery(() => {
  const identityStore = useIdentityStore();
  const brandId = computed(() => identityStore.currentBrand?.id ?? null);

  const { data, ...query } = useQuery({
    enabled: () => brandId.value != null,
    key: () => QueryKeys.libraryIntelligence.starImprovement(brandId.value),
    query: ({ signal }) => getStarImprovement({ brandId: brandId.value! }, { signal }),
    staleTime: CACHE_TIMES.STATIC,
    // Match staleTime so the global 30 min gcTime doesn't evict the entry early
    gcTime: CACHE_TIMES.STATIC,
    autoRefetch: (state) =>
      state.status !== 'error' && state.data && !state.data.ready ? NOT_READY_POLL_MS : false,
  });

  const ready = computed(() => data.value?.ready ?? false);
  const starImprovement = computed(() =>
    ready.value ? (data.value?.starImprovement ?? null) : null,
  );

  return { starImprovement, ready, data, ...query };
});
